import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "widgets flex h-32rem p-4 surface-50"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-7xl" }, "+", -1)
const _hoisted_3 = { class: "text-2xl" }
const _hoisted_4 = { class: "text-xl" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RoutePlannerWidget = _resolveComponent("RoutePlannerWidget")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_AddWidget = _resolveComponent("AddWidget")!
  const _component_EditWidget = _resolveComponent("EditWidget")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.widgets)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_swiper, {
            "slides-per-view": "auto",
            "centered-slides": _ctx.isMobile,
            "space-between": 20,
            class: "w-full",
            threshold: 5
          }, {
            default: _withCtx(() => [
              (_ctx.isRoutePlannerEnabled)
                ? (_openBlock(), _createBlock(_component_swiper_slide, {
                    key: 0,
                    class: "surface-50 w-fit"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_RoutePlannerWidget)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredWidgets, (widget) => {
                return (_openBlock(), _createBlock(_component_swiper_slide, {
                  key: widget.id,
                  class: "surface-50 w-fit"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.components[widget.type as keyof typeof components]), {
                      externalId: widget.external_id,
                      payload: widget.external_data,
                      onEdit: ($event: any) => (_ctx.editWidget(widget))
                    }, null, 40, ["externalId", "payload", "onEdit"]))
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              (_ctx.user && _ctx.filteredWidgets.length < 10)
                ? (_openBlock(), _createBlock(_component_swiper_slide, {
                    key: 1,
                    class: "surface-50 w-fit"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex flex-column gap-4 justify-content-center align-items-center bg-white border-round-3xl border-1 border-300 w-20rem sm:w-25rem h-full cursor-pointer",
                        tabindex: "1",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAddWidget = true)),
                        onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.showAddWidget = true), ["enter"]))
                      }, [
                        _hoisted_2,
                        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("widgets.add")), 1)
                      ], 32)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_ctx.user)
                ? (_openBlock(), _createBlock(_component_swiper_slide, {
                    key: 2,
                    class: "surface-50 w-fit"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex justify-content-center align-items-center bg-white border-round-3xl border-1 border-300 w-20rem sm:w-25rem h-full text-center cursor-pointer",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'Login' }))),
                        onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.$router.push({ name: 'Login' })), ["enter"]))
                      }, [
                        _createElementVNode("span", _hoisted_4, [
                          _createTextVNode(_toDisplayString(_ctx.$t("global.login")) + " ", 1),
                          _hoisted_5,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("widgets.personalize")), 1)
                        ])
                      ], 32)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["centered-slides"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.filteredWidgets)
      ? (_openBlock(), _createBlock(_component_AddWidget, {
          key: 1,
          show: _ctx.showAddWidget,
          currentWidgets: _ctx.filteredWidgets,
          onHide: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showAddWidget = false)),
          onAdd: _cache[5] || (_cache[5] = 
      () => {
        _ctx.showAddWidget = false;
        _ctx.loadWidgets();
      }
    )
        }, null, 8, ["show", "currentWidgets"]))
      : _createCommentVNode("", true),
    (_ctx.filteredWidgets && _ctx.selectedWidget)
      ? (_openBlock(), _createBlock(_component_EditWidget, {
          key: 2,
          show: _ctx.showEditWidget,
          widget: _ctx.selectedWidget,
          currentWidgets: _ctx.filteredWidgets,
          onHide: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showEditWidget = false)),
          onRefresh: _cache[7] || (_cache[7] = 
      () => {
        _ctx.showEditWidget = false;
        _ctx.loadWidgets();
      }
    )
        }, null, 8, ["show", "widget", "currentWidgets"]))
      : _createCommentVNode("", true)
  ], 64))
}